module.exports = __webpack_public_path__ + "img/companyfive.d2b0cf68.png";